import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import "react-data-table-component-extensions/dist/index.css";
import Header from "../layouts/Header";

import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import {  Apitoken, Authtoken } from "../Global";
import {MaterialReactTable} from 'material-react-table';
import Swal from 'sweetalert2';
import  "./../assets/css/custom.css"; 
import FindModuleById from '.././FindModuleById';

import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import AWS from 'aws-sdk';
import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION,AWS_BUCKET } from "../Global";
import {

  MenuItem,

} from '@mui/material';

  
const Users = () => {
  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);
   const [permission, setPermission] = useState({});
 
  useEffect(() => {
     setPermission(FindModuleById(1)); 
   console.log(permission);
    axios
      .post(
        "/users/listing",
        {},
        {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        }
      )
      .then((response) => {

      console.log(response);

        if (response.data.code === 200) {
          setData(response.data.data.users);
        }
        else  if (response.data.code === 401) {
          window.location.href = "/login";
        }else{
          window.location.href = "/login"; 
        }

       
      })
      .catch((error) => {
        setData(error);
        console.log(error);
      });
  }, []);


  const deleteItem = (item) => {

    Swal.fire({
      title: 'Do you really want to delete this record?',
      //text: 'This action cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'DELETE'
    }).then((result) => {
      if (result.isConfirmed) {
        axios.get(`/users/delete/${item}`, {
              headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
            })
            .then((response) => {
              console.log(response);
              if (response.data.code === 200) {
                Swal.fire(
                  'Deleted!',
                  'Your Record has been deleted.',
                  'success'
                );
                setTimeout(() => {
                  window.location.href = "/users";
                }, 500);
              }
            })
            .catch((error) => {
              console.log(error);
            }); 
           }
    });
  }
  const toggleMobileMenu = () => {
    setMenu(!menu);
  };





  const editItem = (item)=>{
    window.location.href = "/users-edit/"+item;
  }
  
AWS.config.setPromisesDependency();
AWS.config.update({
  accessKeyId: AWS_ACCESS_KEY_ID,
  secretAccessKey: AWS_SECRET_ACCESS_KEY,
  region: AWS_DEFAULT_REGION,
  signatureVersion: 'v4',
});

 const s3 = new AWS.S3();
 const EmployeeCell = ({ renderedCellValue, row }) => {
   const profilePicture = row?.original?.profile_picture || '';
   const employeeId = row?.original?.id || '';
   let url = '';
 
   if (profilePicture) {
     const params = { Bucket: AWS_BUCKET, Key: profilePicture };
     url = s3.getSignedUrl('getObject', params);
   }
  return (
         <a href={`/users-view/${employeeId}`} className="">
           <Box
             sx={{
               display: 'flex',
               alignItems: 'center',
               gap: '1rem',
             }}
           >
             <img
               alt="avatar"
               height={70}
               width={70}
               src={url}
               loading="lazy"
               style={{ borderRadius: '100%' }}
             />
             <span>{renderedCellValue}</span>
           </Box>
         </a>
       );
     };
     EmployeeCell.propTypes = {
       renderedCellValue: PropTypes.string.isRequired,
       row: PropTypes.shape({
         original: PropTypes.shape({
           id: PropTypes.number.isRequired,
           profile_picture: PropTypes.string,
         }).isRequired,
       }).isRequired,
     };


// ✅ User Status Cell Component
const UserStatusCell = ({ row }) => {
  const { user_status } = row.original;

  return (
    <div className="btn-group custom-table-btn-group">
      <button
        type="button"
        className="btn btn-block dropdown-toggle me-1"
        style={{ backgroundColor: user_status.bg_color }}
        data-bs-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        {user_status.title}
      </button>
      <div className="dropdown-menu">
        {user_status.id === 1 && (
          <button
            className="dropdown-item btn btn-block"
            onClick={() => changeUserStatus(row.original.id, 0)}
            style={{ backgroundColor: 'red' }}
          >
            INACTIVE
          </button>
        )}
        {user_status.id === 0 && (
          <button
            className="dropdown-item btn btn-block"
            onClick={() => changeUserStatus(row.original.id, 1)}
            style={{ backgroundColor: '#1B2E6B' }}
          >
            ACTIVE
          </button>
        )}
      </div>
    </div>
  );
};

// ✅ PropTypes Validation
UserStatusCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      id: PropTypes.any.isRequired,
      user_status: PropTypes.shape({
        id: PropTypes.number.isRequired,
        title: PropTypes.string.isRequired,
        bg_color: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
};

// ✅ Columns Definition
const columns = [
  // {
  //   header: 'Full Name',
  //   accessorFn: (row) => `${row.first_name} ${row.last_name}`,
  //   Cell: AvatarCell,
  // },
  {
    header: 'Full Name',
    accessorFn: (row) => `${row.first_name} ${row.last_name}`,
    Cell: EmployeeCell,
  },
  {
    header: 'User Position',
    accessorKey: 'user_position',
  },
  {
    header: 'Role',
    accessorKey: 'role.title',
  },
  {
    header: 'Email',
    accessorKey: 'email',
  },
  {
    header: 'Phone Number',
    accessorKey: 'phone_number',
  },
  {
    header: 'User Location',
    accessorKey: 'location.title',
  },
  {
    header: 'User Status',
    Cell: UserStatusCell,
  },
];

const changeUserStatus = (user_id, status) =>{
  Swal.fire({
    title: 'Do you want change Status?',
    //text: 'This action cannot be undone.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: 'green',
    cancelButtonColor: '#d33',
    confirmButtonText: 'CONFIRM',
    customClass: "swal-orders"
  }).then((result) => {
    if (result.isConfirmed) {
      axios.get(`/users/change-status/${user_id}/${status}`, {headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
      .then((response) => {
        if (response.data.code === 200) {
          //setBackendSuccess(response.data.message);
          Swal.fire(
            'Changed!',
            'User Status has been changed Successfully.',
            'success'
          );
          setTimeout(() => {
            window.location.href = "/users";
          }, 500);
        }else{
          //setBackendSuccess(response.data.message);
        }
      }).catch((error) => {
        console.log(error);
      });
         }
  });



}

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />

        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row align-items-center">
                <div className="col">
                  <h3 className="page-title">Users</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item active">Users</li>
                  </ul>
                </div>
                <div className="col-auto">
                 
                  {permission && permission.add === 1 && (
                        <Link   to="/users-add" className="btn btn-primary me-1" >
                        <i className="fas fa-plus"></i>
                      </Link>
                    )} 
                </div>
              </div>
            </div>

          

            <div className="row">
          
                  <div className="col-sm-12">
                    <div className="card card-table">
                      <div className="card-body">
                        <div className="table-responsive">
                        {permission && permission.list === 1 && ( 

                        <MaterialReactTable columns={columns} data={data} 
                        enableColumnOrdering
                        enablePinning
                        enableRowActions
                        //renderColumnActionsMenuItems 
                        renderRowActionMenuItems={({ row }) => [
                            permission?.update === 1 && (
                              <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                                Edit
                              </MenuItem>
                            ),
                            permission?.delete === 1 && (
                              <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                Delete
                              </MenuItem>
                            ),
                          ]}
                      />
                        )}
                        </div>
                      
                      </div>
                    </div>
                  </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Users;
